import ArchModel from "./ArchModel";
import { useGLTF } from "@react-three/drei";

// Preload calls removed to allow progressive streaming via Suspense fallback

export default function ArchSection() {
  return (
    <>
      <ArchModel
        projectName="777 Airport Blvd"
        modelPath="./models/arch/777massing.glb"
        pdfFileName="02G777Airport.pdf"
        position={[-5, 0, 6]}
        scale={0.015}
      />
      <ArchModel
        projectName="Nanning ASEAN"
        modelPath="./models/arch/Nanning.glb"
        pdfFileName="03Nanning.pdf"
        position={[-5, 0, 15]}
        scale={0.05}
        focusYaw={-Math.PI / 4}
      />
      <ArchModel
        projectName="Foshan Poly"
        modelPath="./models/arch/Foshan.glb"
        pdfFileName="05Foshan.pdf"
        position={[-10, 0, 22]}
        scale={0.05}
        rotation={[0, (2 * Math.PI) / 4, 0]}
      />
      <ArchModel
        projectName="Hangzhou SUNAC"
        modelPath="./models/arch/SUNAC.glb"
        pdfFileName="06SUNAC.pdf"
        position={[-15, 0, 30]}
        scale={0.05}
        focusYaw={-Math.PI / 2}
      />
      <ArchModel
        projectName="Beijing Lize"
        modelPath="./models/arch/Lize.glb"
        pdfFileName="04Lize.pdf"
        position={[-8, 0, 40]}
        scale={0.05}
        rotation={[0, (2 * Math.PI) / 4, 0]}
      />
      <ArchModel
        projectName="SFO T3W"
        modelPath="./models/arch/SFO.glb"
        pdfFileName="01SFOT3W.pdf"
        position={[-38, 0, 15]}
        scale={0.02}
        rotation={[0, (2 * Math.PI) / 2 - 1.09, 0]}
        focusYaw={-Math.PI / 4}
        focusZoom={2}
      />
      <ArchModel
        projectName="Kula Belgrade"
        modelPath="./models/arch/Belgrade.glb"
        pdfFileName="07Belgrade.pdf"
        position={[-20, 0, 45]}
        scale={0.05}
        rotation={[0, (2 * Math.PI) / 2, 0]}
        focusYaw={-Math.PI / 4}
      />
      <ArchModel
        projectName="Xian GreenLand"
        modelPath="./models/arch/XXGL.glb"
        pdfFileName="08XiAn.pdf"
        position={[-30, 0, 40]}
        scale={0.05}
        rotation={[0, (2 * Math.PI) / 4, 0]}
      />
      <ArchModel
        projectName="Shenzhen Shimao"
        modelPath="./models/arch/SZShimao.glb"
        pdfFileName="09Shimao.pdf"
        position={[-40, 0, 40]}
        scale={0.05}
        focusYaw={-Math.PI / 2}
      />
    </>
  );
}
